import React from 'react';
import { Link } from '@qred/components-library';
import useTranslate from './useTranslate';
import useCardLinks from './links/useCardLinks';

const useCardConsentText = () => {
  const t = useTranslate();
  const {
    openProductTerms,
    openPriceList,
    openGeneralTerms,
    usesMigratedTermsKeys,
  } = useCardLinks();

  // Migrated markets: ConsentText with descriptive tokens. generalTermsLink is
  // always passed but only renders if that market's ConsentText includes it.
  if (usesMigratedTermsKeys) {
    return t('CreditCardTermsAndConditionsCard.ConsentText', {
      generalTermsLink: (
        <Link size="sm" onClick={openGeneralTerms}>
          {t('CreditCardTermsAndConditionsCard.GeneralTerms')}
        </Link>
      ),
      productTermsLink: (
        <Link size="sm" onClick={openProductTerms}>
          {t('CreditCardTermsAndConditionsCard.ProductTermsCardLinkText')}
        </Link>
      ),
      priceListLink: (
        <Link size="sm" onClick={openPriceList}>
          {t('CreditCardTermsAndConditionsCard.PriceListingLinkText')}
        </Link>
      ),
    });
  }

  // TODO: legacy fallback for non-migrated markets — delete once all are migrated.
  // Text3 tokens are misnamed: generalTermLink = product terms
  return t('CreditCardTermsAndConditionsCard.Text3', {
    generalTermLink: (
      <Link size="sm" onClick={openProductTerms}>
        {t('CreditCardTermsAndConditionsCard.Link1')}
      </Link>
    ),
    qredCardPricesLink: (
      <Link size="sm" onClick={openPriceList}>
        {t('CreditCardTermsAndConditionsCard.PriceListingLinkText')}
      </Link>
    ),
  });
};

export default useCardConsentText;
